import * as types from './mutation-types'

export const mutations = {
  SET_CHATTOKEN: (state, token) => {
    state.chatToken = token
  },   
  [types.INIT_USER_INFO] (state, o) {
    state.profile = o
  },
  [types.SET_LOGIN_STATE] (state, b) {
    state.isLogin = b
  },
  [types.INIT_GETLETTERLIST] (state, b) {
    state.getLetterList = b
  },
  [types.INIT_SENDLETTERLIST] (state, b) {
    state.sendLetterList = b
  },
  [types.INIT_ACCOUNTRECORDLIST] (state, b) {
    state.accountRecordList = b
  },
  [types.INIT_COMPLAINLIST] (state, b) {
    state.complainList = b
  },
  [types.INIT_HELPLIST] (state, b) {
    state.helpList = b
  },
  [types.INIT_SIGNDATA] (state, b) {
    state.signData = b
  },
  [types.INIT_GAMEDATALIST] (state, b) {
    state.gameDataList = b
  },
  [types.INIT_GAMEMAPDATALIST] (state, b) {
    state.gameMapDataList = b
  }
}



// WEBPACK FOOTER //
// ./src/logic/user/mutations.js